module.exports = __webpack_public_path__ + "static/media/haju.e5ca8994.jpg";